import React from "react";
import { render } from "react-dom";
import App from "./components/App";
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "@apollo/react-hooks";

const client = new ApolloClient({
  uri: `${window.location.origin}${drupalSettings.path.baseUrl}graphql`,
});

const Index = () => {
  return (
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
};
render(<Index />, document.getElementById("wizard-block"));
